import React, {useEffect, useRef, useState} from 'react';
import { useLocation } from 'react-router-dom';
import {PanelMenu} from "primereact/panelmenu";
import items from "data/main-menu.json"
import {useUserProfileQuery} from "apis/authenticationApi";

const MainMenu = () => {
    const location = useLocation();
    const {data} = useUserProfileQuery();
    const menuItems = useRef(items);
    const [key, setKey] = useState(0);
    const [expanded, setExpanded] = useState(false);

    useEffect(() => {
        menuItems.current.forEach(menuItem => {
            let found = false;
            menuItem.expanded = false;
            menuItem.className = undefined;

            if(menuItem.roles?.length &&
                !menuItem.roles.includes(data?.role) &&
                !menuItem.roles.includes(data?.company?.role)) {
                menuItem.className = "hidden";
            }

            if(menuItem?.items?.length) {
                menuItem.items.forEach(subItem => {
                    subItem.className = undefined;

                    if (subItem.roles?.length &&
                        !subItem.roles.includes(data?.role) &&
                        !subItem.roles.includes(data?.company?.role)) {
                        subItem.className = "hidden";
                    } else if (!found && (location.pathname.startsWith(subItem.url.substring(2)) || (location.pathname === '/' && subItem.defaultPath))) {
                        menuItem.expanded = true;
                        subItem.className = "active";
                        found = true;
                    }
                });
            }
        });

        setKey(key => key + 1);
    }, [data?.company?.role, data?.role, location.pathname]);

    return (
        <div className="mainmenu-dropdown">
            <div className={expanded ? "mainmenu-dropdown-trigger expanded" : `mainmenu-dropdown-trigger`} onClick={() => setExpanded(!expanded) }>Main Menu</div>
            <div className={expanded ? "mainmenu-dropdown-content expanded" : `mainmenu-dropdown-content`}>
                <PanelMenu key={key} model={menuItems.current} />
            </div>
        </div>
    );
}

export default MainMenu;
